import { render } from "./AppointmentInfo.vue?vue&type=template&id=47e4bbc1"
import script from "./AppointmentInfo.vue?vue&type=script&lang=js"
export * from "./AppointmentInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__